import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************
class serverOrderRequestApi {

    static getResource(catalogId: string) {
        return sendRequest(
            requestOptions(config.URL + `catalog/${catalogId}`,
                requestTypes.GET,
            ),
        );
    }

    static getShippingLocations()
    {
        return sendRequest(
            requestOptions(config.URL + `shipping-locations`,
                requestTypes.GET,
            ),
        );
    }

    static getStudents(studentSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(studentSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${config.URL}students/patrons?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }

    static getPublishers()
    {
        return sendRequest(
            requestOptions(config.URL + `catalog/publishers`,
                requestTypes.GET,
            ),
        );
    }

    static addOrder(orderRequestModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(`${config.URL}orders`,
                requestTypes.POST,
                JSON.stringify(orderRequestModel),
                apiConstants.successMessage.order.ADD
            ),
        );
    }

    static getOrder(orderId: string) {
        return sendRequest(
            requestOptions(config.URL + `orders/${orderId}/queue`,
                requestTypes.GET,
            ),
        );
    }

    static cancelOrder(orderId: string) {
        return sendRequest(
            requestOptions(`${config.URL}orders/${orderId}/cancel`,
                requestTypes.PUT,
                apiConstants.successMessage.order.CANCEL
            ),
        );
    }
}

export const orderRequestApi = config.environment.MODE === config.modes.SERVER ? serverOrderRequestApi : serverOrderRequestApi;
